class EcomMindsAnimatedDetailsBase extends HTMLElement {
  setup(detailsSelector, summarySelector, panelSelector) {
    this.details = this.querySelector(detailsSelector);
    this.summary = this.querySelector(summarySelector);
    this.panel = this.querySelector(panelSelector);

    if (!this.details || !this.summary || !this.panel) return false;

    this.duration = 330;
    this.easing = 'cubic-bezier(0.22, 1, 0.36, 1)';
    this.animation = null;
    this.animating = false;

    this.summary.addEventListener('click', this.onClick);

    if (this.details.open) {
      this.panel.style.height = 'auto';
      this.panel.style.opacity = '1';
    } else {
      this.panel.style.height = '0px';
      this.panel.style.opacity = '0';
    }

    return true;
  }

  disconnectedCallback() {
    this.summary?.removeEventListener('click', this.onClick);
    this.animation?.cancel();
  }

  get reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  onClick = (event) => {
    event.preventDefault();
    if (this.animating) return;

    if (this.details.open) this.close();
    else this.open();
  };

  open() {
    this.animating = true;
    this.details.open = true;

    this.panel.style.height = 'auto';
    const targetHeight = this.panel.scrollHeight;

    this.animation?.cancel();
    this.animation = this.panel.animate(
      [
        { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
        { height: `${targetHeight}px`, opacity: 1, transform: 'translateY(0)' }
      ],
      {
        duration: this.reducedMotion ? 0 : this.duration,
        easing: this.easing
      }
    );

    this.animation.onfinish = () => {
      this.panel.style.height = 'auto';
      this.panel.style.opacity = '1';
      this.panel.style.transform = '';
      this.animating = false;
    };

    this.animation.oncancel = () => {
      this.animating = false;
    };
  }

  close() {
    this.animating = true;
    const startHeight = this.panel.getBoundingClientRect().height;

    this.animation?.cancel();
    this.animation = this.panel.animate(
      [
        { height: `${startHeight}px`, opacity: 1, transform: 'translateY(0)' },
        { height: '0px', opacity: 0, transform: 'translateY(-4px)' }
      ],
      {
        duration: this.reducedMotion ? 0 : this.duration,
        easing: this.easing
      }
    );

    this.animation.onfinish = () => {
      this.details.open = false;
      this.panel.style.height = '0px';
      this.panel.style.opacity = '0';
      this.panel.style.transform = '';
      this.animating = false;
    };

    this.animation.oncancel = () => {
      this.animating = false;
    };
  }
}

class EcomMindsFaqGroup extends EcomMindsAnimatedDetailsBase {
  connectedCallback() {
    this.setup(
      '[data-em-faq-group-details]',
      '[data-em-faq-group-summary]',
      '[data-em-faq-group-panel]'
    );
  }
}

class EcomMindsFaqItem extends EcomMindsAnimatedDetailsBase {
  connectedCallback() {
    this.setup(
      '[data-em-faq-details]',
      '[data-em-faq-summary]',
      '[data-em-faq-panel]'
    );
  }
}

if (!customElements.get('ecomminds-faq-group')) {
  customElements.define('ecomminds-faq-group', EcomMindsFaqGroup);
}

if (!customElements.get('ecomminds-faq-item')) {
  customElements.define('ecomminds-faq-item', EcomMindsFaqItem);
}
